export default class AdoptionActions {
  // namespace actions adoptions
  static ADOPTIONS_FETCH_REQUEST = 'ADOPTIONS_FETCH_REQUEST'
  static ADOPTIONS_FETCH_SUCCESS = 'ADOPTIONS_FETCH_SUCCESS'
  static ADOPTIONS_FETCH_ERROR = 'ADOPTIONS_FETCH_ERROR'
  static ADOPTIONS_DELETE_REQUEST = 'ADOPTION_DELETE_REQUEST'
  static ADOPTIONS_DELETE_SUCCESS = 'ADOPTION_DELETE_SUCCESS'
  static ADOPTIONS_DELETE_ERROR = 'ADOPTIONS_DELETE_ERROR'

  // namespace actions STATIONERY
  static STATIONERY_FETCH_REQUEST = 'ADOPTIONS_STATIONERY_FETCH_REQUEST'
  static STATIONERY_FETCH_SUCCESS = 'ADOPTIONS_STATIONERY_FETCH_SUCCESS'
  static STATIONERY_FETCH_ERROR = 'ADOPTIONS_STATIONERY_FETCH_ERROR'

  // namespace actions adoptions
  static ADOPTIONS_SEND_FETCH_REQUEST = 'ADOPTIONS_SEND_FETCH_REQUEST'
  static ADOPTIONS_SEND_FETCH_SUCCESS = 'ADOPTIONS_SEND_FETCH_SUCCESS'
  static ADOPTIONS_SEND_FETCH_ERROR = 'ADOPTIONS_SEND_FETCH_ERROR'

  // namespace actions segments
  static SEGMENTS_FETCH_REQUEST = 'SEGMENTS_FETCH_REQUEST'
  static SEGMENTS_FETCH_SUCCESS = 'SEGMENTS_FETCH_SUCCESS'
  static SEGMENTS_FETCH_ERROR = 'SEGMENTS_FETCH_ERROR'

  // namespace actions grades
  static GRADES_ADD = 'GRADES_ADD'
  static SET_GRADES_SELECTED = 'GRADES_SELECTED'

  // namespace actions filters
  static FILTER_SET_GRADE_ID = 'FILTER_SET_GRADE_ID'
  static FILTER_SET_SUBJECT_IDS = 'FILTER_SET_SUBJECT_IDS'
  static FILTER_SET_TEACHER_IDS = 'FILTER_SET_TEACHER_IDS'
  static FILTER_SET_STATUS = 'FILTER_SET_STATUS'
  static ADOPTIONS_CHANGE_ADVANCED_FILTER = 'ADOPTIONS_CHANGE_ADVANCED_FILTER'
  static ADOPTION_CHANGE_FILTER = 'ADOPTION_CHANGE_FILTER'
  static ADOPTION_FILTER_RESET = 'ADOPTION_FILTER_RESET'

  // namespace actions adoptions counters adopted
  static SEGMENTS_FETCH_REQUEST = 'SEGMENTS_FETCH_REQUEST'
  static SEGMENTS_FETCH_SUCCESS = 'SEGMENTS_FETCH_SUCCESS'
  static SEGMENTS_FETCH_ERROR = 'SEGMENTS_FETCH_ERROR'

  // namespace actions adoptions counters adopted
  static ADOPTION_DUE_DATE_FETCH_REQUEST = 'ADOPTION_DUE_DATE_FETCH_REQUEST'
  static ADOPTION_DUE_DATE_FETCH_SUCCESS = 'ADOPTION_DUE_DATE_FETCH_SUCCESS'
  static ADOPTION_DUE_DATE_FETCH_ERROR = 'ADOPTION_DUE_DATE_FETCH_ERROR'

  // namespace actions adoptions counters adopted
  static ADOPTION_DUE_DATE_CHANGE_REQUEST = 'ADOPTION_DUE_DATE_CHANGE_REQUEST'
  static ADOPTION_DUE_DATE_CHANGE_SUCCESS = 'ADOPTION_DUE_DATE_CHANGE_SUCCESS'
  static ADOPTION_DUE_DATE_CHANGE_ERROR = 'ADOPTION_DUE_DATE_CHANGE_ERROR'

  // namespace actions adoptions counters adopted
  static ADOPTION_STATUS_CHANGE_REQUEST = 'ADOPTION_STATUS_CHANGE_REQUEST'
  static ADOPTION_STATUS_CHANGE_SUCCESS = 'ADOPTION_STATUS_CHANGE_SUCCESS'
  static ADOPTION_STATUS_CHANGE_ERROR = 'ADOPTION_STATUS_CHANGE_ERROR'

  // namespace actions adoptions counters peding
  static ADOPTIONS_COUNTER_ADOPTED_FETCH_REQUEST = 'ADOPTIONS_COUNTER_ADOPTED_FETCH_REQUEST'
  static ADOPTIONS_COUNTER_ADOPTED_FETCH_SUCCESS = 'ADOPTIONS_COUNTER_ADOPTED_FETCH_SUCCESS'
  static ADOPTIONS_COUNTER_ADOPTED_FETCH_ERROR = 'ADOPTIONS_COUNTER_ADOPTED_FETCH_ERROR'

  // namespace actions adoptions counters pending
  static ADOPTIONS_COUNTER_PENDING_FETCH_REQUEST = 'ADOPTIONS_COUNTER_PENDING_FETCH_REQUEST'
  static ADOPTIONS_COUNTER_PENDING_FETCH_SUCCESS = 'ADOPTIONS_COUNTER_PENDING_FETCH_SUCCESS'
  static ADOPTIONS_COUNTER_PENDING_FETCH_ERROR = 'ADOPTIONS_COUNTER_PENDING_FETCH_ERROR'
  // namespace actions modal
  static ADOPTION_MODAL_TOGGLE_VIEW = 'ADOPTION_MODAL_TOGGLE_VIEW'
  static ADOPTION_MODAL_CHANGE_ITEM = 'ADOPTION_MODAL_CHANGE_ITEM'

  // namespace actions modal
  static ADOPTIONS_MODAL_TOGGLE_VIEW = 'ADOPTIONS_MODAL_TOGGLE_VIEW'

  // namespace actions modal
  static ADOPTION_CHANGE_PAGE = 'ADOPTION_CHANGE_PAGE'
  static ADOPTION_STATIONERY_CHANGE_PAGE = 'ADOPTION_STATIONERY_CHANGE_PAGE'

  static TRIGGER_FETCH_ADOPTIONS_TO_BE_SENT = 'TRIGGER_FETCH_ADOPTIONS_TO_BE_SENT'

  // actions adoptions
  static fetchAdoptionsRequest () {
    return {
      type: AdoptionActions.ADOPTIONS_FETCH_REQUEST
    }
  }

  static fetchAdoptionsSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_FETCH_SUCCESS,
      payload
    }
  }

  static fetchAdoptionsError (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_FETCH_ERROR,
      payload
    }
  }

  static deleteAdoptionRequest () {
    return {
      type: AdoptionActions.ADOPTIONS_DELETE_REQUEST
    }
  }

  static deleteAdoptionsSuccess (payload) {
    return {
      tyé: AdoptionActions.ADOPTIONS_DELETE_SUCCESS,
      payload
    }
  }

  static deleteAdoptionsError (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_FETCH_ERROR,
      payload
    }
  }

  // actions stationery
  static fetchStationeryRequest () {
    return {
      type: AdoptionActions.STATIONERY_FETCH_REQUEST
    }
  }

  static fetchStationerySuccess (payload) {
    return {
      type: AdoptionActions.STATIONERY_FETCH_SUCCESS,
      payload
    }
  }

  static fetchStationeryError (payload) {
    return {
      type: AdoptionActions.STATIONERY_FETCH_ERROR,
      payload
    }
  }

  // actions adoptions
  static fetchAdoptionsSendRequest () {
    return {
      type: AdoptionActions.ADOPTIONS_SEND_FETCH_REQUEST
    }
  }

  static fetchAdoptionsSendSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_SEND_FETCH_SUCCESS,
      payload
    }
  }

  static fetchAdoptionsSendError (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_SEND_FETCH_ERROR,
      payload
    }
  }

  // actions segmments
  static fetchSegmentsRequest () {
    return {
      type: AdoptionActions.SEGMENTS_FETCH_REQUEST
    }
  }

  static fetchSegmentsSuccess (payload) {
    return {
      type: AdoptionActions.SEGMENTS_FETCH_SUCCESS,
      payload
    }
  }

  static fetchSegmentsError (payload) {
    return {
      type: AdoptionActions.SEGMENTS_FETCH_ERROR,
      payload
    }
  }

  // actions Adoption Due Date
  static fetchAdoptionDueDateRequest () {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_FETCH_REQUEST
    }
  }

  static fetchAdoptionDueDateSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_FETCH_SUCCESS,
      payload
    }
  }

  static fetchAdoptionDueDateError (payload) {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_FETCH_ERROR,
      payload
    }
  }

  // actions Adoption Due Date
  static changeAdoptionDueDateRequest () {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_CHANGE_REQUEST
    }
  }

  static changeAdoptionDueDateSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_CHANGE_SUCCESS,
      payload
    }
  }

  static changeAdoptionDueDateError (payload) {
    return {
      type: AdoptionActions.ADOPTION_DUE_DATE_CHANGE_ERROR,
      payload
    }
  }

  // actions Adoption Due Date
  static changeAdoptionStatusRequest () {
    return {
      type: AdoptionActions.ADOPTION_STATUS_CHANGE_REQUEST
    }
  }

  static changeAdoptionStatusSuccess () {
    return {
      type: AdoptionActions.ADOPTION_STATUS_CHANGE_SUCCESS
    }
  }

  static changeAdoptionStatusError (payload) {
    return {
      type: AdoptionActions.ADOPTION_STATUS_CHANGE_ERROR,
      payload
    }
  }

  // actions adotions counter adopted
  static fetchAdoptionsCounterAdoptedRequest () {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_REQUEST
    }
  }

  static fetchAdoptionsCounterAdoptedSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_SUCCESS,
      payload
    }
  }

  static fetchAdoptionsCounterAdoptedError (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_ERROR,
      payload
    }
  }

  // actions adotions counter adopted
  static fetchAdoptionsCounterPendingRequest () {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_REQUEST
    }
  }

  static fetchAdoptionsCounterPendingSuccess (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_SUCCESS,
      payload
    }
  }

  static fetchAdoptionsCounterPendingError (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_ERROR,
      payload
    }
  }

  // actions grades
  static addGrades (payload) {
    return {
      type: AdoptionActions.GRADES_ADD,
      payload
    }
  }
  static setSelectedGrades (payload) {
    return {
      type: AdoptionActions.SET_GRADES_SELECTED,
      payload
    }
  }

  // actions filters
  static setFilterGradeId (payload) {
    return {
      type: AdoptionActions.FILTER_SET_GRADE_ID,
      payload
    }
  }
  static setFilterSubjectIds (payload) {
    return {
      type: AdoptionActions.FILTER_SET_SUBJECT_IDS,
      payload
    }
  }
  static setFilterTeacherIds (payload) {
    return {
      type: AdoptionActions.FILTER_SET_TEACHER_IDS,
      payload
    }
  }
  static setFilterStatus (payload) {
    return {
      type: AdoptionActions.FILTER_SET_STATUS,
      payload
    }
  }
  static changeAdvancedFilter (payload) {
    return {
      type: AdoptionActions.ADOPTIONS_CHANGE_ADVANCED_FILTER,
      payload
    }
  }
  static changeFilter (payload) {
    return {
      type: AdoptionActions.ADOPTION_CHANGE_FILTER,
      payload
    }
  }
  // actions modal
  static DialogToggleView () {
    return {
      type: AdoptionActions.ADOPTION_MODAL_TOGGLE_VIEW
    }
  }
  static DialogChangeItem (payload) {
    return {
      type: AdoptionActions.ADOPTION_MODAL_CHANGE_ITEM,
      payload
    }
  }
  static ModalToggleView () {
    return {
      type: AdoptionActions.ADOPTIONS_MODAL_TOGGLE_VIEW
    }
  }

  // actions page
  static changePageAdotion (payload) {
    return {
      type: AdoptionActions.ADOPTION_CHANGE_PAGE,
      payload
    }
  }

  static changeStationeryPageAdotion (payload) {
    return {
      type: AdoptionActions.ADOPTION_STATIONERY_CHANGE_PAGE,
      payload
    }
  }
  static triggerFetchAdoptionsToBeSent () {
    return {
      type: AdoptionActions.TRIGGER_FETCH_ADOPTIONS_TO_BE_SENT
    }
  }

  static resetAdoptionFilter () {
    return {
      type: AdoptionActions.ADOPTION_FILTER_RESET
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/adoption/actions.js